<!-- free-resourse.component.html -->

<div class="offers-page">
  
  <!-- Hero Banner Section -->
  <div class="offers-hero-banner">
    <div class="hero-content">
      <div class="hero-subtitle">Exclusive Learning Opportunities</div>
      <h1 class="hero-title">
        Transform Your Future with Our <span class="highlight">Special Offers</span>
      </h1>
      <p class="hero-description">
        Unlock premium courses, certifications, and learning resources at unbeatable prices. 
        Start your educational journey today with our limited-time offers.
      </p>
      <button class="hero-btn" (click)="scrollToOffers()">
        Explore Offers
      </button>
    </div>
    <div class="hero-image">
      <img [src]="heroImage()" alt="Latest Offer" />
    </div>
  </div>

  <!-- Offers Section -->
  <div class="offers-section" id="offers-list">
    <div class="section-header">
      <h2>Hot Offers 🔥</h2>
    </div>

    <!-- Error State -->
    <div *ngIf="error" class="error-message">
      {{ error }}
    </div>

    <!-- Loading State -->
    <div *ngIf="loading" class="loading-spinner">
      Loading amazing offers...
    </div>

    <!-- Categories -->
    <div *ngIf="!loading && !error" class="category-filter">
      <button *ngFor="let c of categories"
              class="cat-pill"
              [class.active]="activeCategory === c"
              (click)="setCategory(c)">
        {{ c | titlecase }}
      </button>
    </div>

    <!-- Offers Grid -->
    <!-- Offers Grid -->
<div *ngIf="!loading && !error && filteredOffers.length" class="offers-grid">
  <div class="offer-card fade-in"
       *ngFor="let o of filteredOffers">
    <img [src]="imageSrc(o)" [alt]="o.title || 'Offer'">
    
    <!-- Badge -->
    <span *ngIf="o.category" class="offer-badge">{{ o.category }}</span>
    
    <!-- Overlay -->
    <div class="offer-overlay">
      <span class="offer-title">{{ o.title || 'View Offer' }}</span>
      <span class="offer-description">{{ o.description }}</span>
      <button class="claim-offer-btn" (click)="onImageClick(o)">Claim Offer</button>
    </div>
  </div>
</div>

    <!-- No Data State -->
    <p class="no-data" *ngIf="!loading && !error && !filteredOffers.length">
      No offers found in this category.
    </p>
  </div>

</div>